document.addEventListener("DOMContentLoaded", () => {
  $(".product-class-wrapper .product-class-inner .product-class").click(
    function () {
      let index = $(this).attr("data-index");
      $(this).addClass("active").siblings().removeClass("active");
      $(`.choose-product-wrapper .choose-product-${index}`)
        .addClass("active")
        .siblings()
        .removeClass("active");
    }
  );

  // overflow-x 除了滚动条能滚动内容，鼠标也可以滑动内容
  function contentScrolling(className) {
    const scrollContainer = document.querySelector(className);
    let isDown = false;
    let startX;
    let scrollLeft;

    scrollContainer.addEventListener("mousedown", (e) => {
      isDown = true;
      scrollContainer.classList.add("active");
      startX = e.pageX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
    });

    scrollContainer.addEventListener("mouseleave", () => {
      isDown = false;
      scrollContainer.classList.remove("active");
    });

    scrollContainer.addEventListener("mouseup", () => {
      isDown = false;
      scrollContainer.classList.remove("active");
    });

    scrollContainer.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - scrollContainer.offsetLeft;
      const walk = (x - startX) * 3; // 3 is the scroll speed multiplier
      scrollContainer.scrollLeft = scrollLeft - walk;
    });
  }
  contentScrolling(".bundle-content");

  // review 数字
  $(".choose-product .item").each(function () {
    var r_val = $(this).find(".stamped-badge-caption").data("reviews");
    $(this).find(".stamped-badge-caption").text(`(${r_val})`);
  });

  // load-more
  $(".load-more").click(function () {
    $(this).siblings(".swiper-wrapper").find(".item").css("display", "block");
    $(this).css("display", "none");
  });

  $(".choose-product").each(function () {
    if (!($(this).find(".item").length > 6)) {
      $(this).find(".load-more").css("display", "none");
    }
  });

  var swiperInstances = [];

  var initSwiper = function () {
    var productList = $(".choose-product");

    productList.each(function (index, element) {
      var ItemNum = $(this).find(".item").length;
      var double = Math.ceil(ItemNum / 2);

      var swiper = new Swiper(element, {
        slidesPerView: 5,
        spaceBetween: 25,
        grid: {
          rows: 1,
        },
        navigation: {
          nextEl: $(element).find(".swiper-button-next")[0],
          prevEl: $(element).find(".swiper-button-prev")[0],
        },
        breakpoints: {
          1200: {
            slidesPerView: 5,
            spaceBetween: 25,
            grid: {
              rows: 1,
            },
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 20,
            grid: {
              rows: 1,
            },
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            grid: {
              rows: 1,
            },
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 0,
            grid: {
              rows: double,
            },
          },
          300: {
            slidesPerView: 2,
            spaceBetween: 0,
            grid: {
              rows: double,
            },
          },
        },
      });

      swiperInstances.push(swiper);
    });
  };

  // 小于 768px 时销毁 Swiper
  var destroySwiper = function () {
    swiperInstances.forEach(function (swiper) {
      if (swiper) {
        swiper.destroy(true, true);
      }
    });
    swiperInstances = [];
  };

  var handleResize = function () {
    var width = $(window).width();
    if (width < 769) {
      destroySwiper();
      $(".save-inner").css("height", "60px");
      $(".save-inner").find(".add-svg").css("top", "48px");
      changeHeight("#app1");
      changeHeight("#app2");
    } else {
      destroySwiper();
      initSwiper();
      $(".save-inner").find(".add-svg").css("top", "50%");
      $(".save-inner").css("height", "240px");
      $(".save-inner").css("justify-content", "center");
    }
  };

  handleResize();

  $(window).resize(function () {
    handleResize();
  });

  function changeHeight(className) {
    var eleLists = $(".save-inner");

    if (eleLists.length > 0) {
      eleLists.each(function () {
        if ($(this).find(".product-wrapper").length > 0) {
          $(this).css("height", "128px");
          $(this).find(".add-svg").css("top", "115px");
          $(this).css("justify-content", "flex-start");
        }
      });
    }
  }

  // 弹窗
  $(".bundle-add-btn").click(function () {
    var parentID = "";
    var parentElement = $(this).parents(".bundle-sale-module");
    parentID = parentElement.attr("id");

    var img = $(this)
      .parents(".home-product-card-wrapper")
      .find(".home-product-card-img img")
      .attr("src");

    setTimeout(function () {
      var bundleBtn = $(".add-to-bundle");

      if (bundleBtn.length > 0) {
        bundleBtn.click(function () {
          var title = $(this).attr("title");
          var salePrice = Number(
            $(
              "quick-add-modal product-info .price__regular .price-item--regular"
            )
              .text()
              .replace(/[^0-9.]/g, "")
          );
          var originPrice = "";
          var discount = 0;

          var item = $(
            "quick-add-modal product-info .price__sale .price-item--regular"
          )
            .text()
            .trim();

          if (item !== "") {
            originPrice = Number(item.replace(/[^0-9.]/g, ""));
          } else {
            originPrice = 0;
          }

          // 获取变体id
          var list = [];
          var id = "";
          $(".product-form__input--pill input[type=radio]:checked+label").each(
            function () {
              var variant = $(this).text().trim();
              list.push(variant);
            }
          );
          var variantList = $(".variant-option");
          variantList.each(function () {
            var text = $(this).text().trim();

            const containsAll = list.every((value) => text.includes(value));

            if (containsAll) {
              id = $(this).attr("value");
            }
          });

          var num = $("quick-add-modal .quantity__input").val();

          for (let i = 0; i < num; i++) {
            if (parentID === "app1") {
              app.add_to_bundle(
                img,
                title,
                salePrice,
                originPrice,
                id,
                discount
              );
            } else {
              app2.add_to_bundle(
                img,
                title,
                salePrice,
                originPrice,
                id,
                discount
              );
            }
          }

          var state = false;

          setTimeout(function () {
            if (parentID === "app1") {
              state = false;
              innerColor(state, "#app1");
              $("#app1 .save-inner .delete-product").click(function () {
                state = true;
                innerColor(state, "#app1");
              });

              let top_h =
                $("#app1 .section-bundle-sale-product").offset().top - 100;
              $("html,body").animate({ scrollTop: top_h }, 100);
            } else {
              state = false;
              innerColor(state, "#app2");
              $("#app2 .save-inner .delete-product").click(function () {
                state = true;
                innerColor(state, "#app2");
              });

              let top_h =
                $("#app2 .section-bundle-sale-product").offset().top - 100;
              $("html,body").animate({ scrollTop: top_h }, 100);
              $(".zoomContainer").css("display", "none");
            }
          }, 0);

          $(".quick-add-modal").removeAttr("open");
          $(".quick-add-modal .quick-add-modal__content-info").empty();
          $("body").removeClass("overflow-hidden");

          console.log(salePrice);
          console.log(originPrice);
        });
      }
    }, 2000);
  });

  function innerColor(state, className) {
    setTimeout(function () {
      var element = $(`${className} .save-wrapper .save-inner.active`);
      var width = $(window).width();

      if (state) {
        element.css("background-color", "#339bcb1a");
        element.css("justify-content", "center");

        if (width < 769) {
          element.css("height", "60px");
          element.find(".add-svg").css("top", "48px");
        } else {
          element.css("height", "240px");
          element.find(".add-svg").css("top", "50%");
        }
      }

      var eleLists = $(".save-inner");

      if (eleLists.length > 0) {
        $(`${className} .save-wrapper .save-inner`).css(
          "background-color",
          "#339bcb1a"
        );

        eleLists.each(function () {
          if ($(this).find(".product-wrapper").length > 0) {
            $(this).css("background-color", "#fff");

            if (width < 769) {
              $(this).css("height", "128px");
              $(this).find(".add-svg").css("top", "115px");
              $(this).css("justify-content", "flex-start");
            }
          }
        });
      }
    }, 100);
  }
});
